export const LOCALES = ["es-MX", "en-US"] as const
export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = "es-MX"
// Fallback intentionally points at Spanish — if a key is missing from en-US
// we'd rather show Spanish than the raw key.
export const FALLBACK_LOCALE: Locale = "es-MX"

export const NAMESPACES = [
  "common",
  "auth",
  "overview",
  "errors",
  "institutions",
  "schools",
  "professors",
  "admin-users",
  "onboarding",
  // PRD-33 / ADR-0030 — public account-activation (set-password) page at
  // /activar/:token.
  "account-activation",
  "settings",
  // PRD-56 §FR-14 — the bitácora's sentences, one per audited action.
  "audit",
  // PRD-69 — the "Materiales" tab (staff-managed materials).
  "staff-materials",
] as const
export type Namespace = (typeof NAMESPACES)[number]

export const LOCALE_STORAGE_KEY = "platonica_admin_locale"

export const LOCALE_LABELS: Record<Locale, string> = {
  "es-MX": "Español (MX)",
  "en-US": "English (US)",
}
